export function wrapSourcePositionMs({ sourceTimeSec = 0, durationMs = 0, loopRange = null } = {}) {
  const sourceMs = Number(sourceTimeSec) * 1000;
  if (!Number.isFinite(sourceMs)) return null;

  const loopStart = Number(loopRange?.start);
  const loopEnd = Number(loopRange?.end);
  const hasLoop = Number.isFinite(loopStart) && Number.isFinite(loopEnd) && loopEnd > loopStart;
  const loopLength = hasLoop ? loopEnd - loopStart : null;

  if (hasLoop && loopLength > 0) {
    const offset = ((sourceMs - loopStart) % loopLength + loopLength) % loopLength;
    return loopStart + offset;
  }

  const totalDuration = Number(durationMs);
  if (Number.isFinite(totalDuration) && totalDuration > 0) {
    return ((sourceMs % totalDuration) + totalDuration) % totalDuration;
  }

  return Math.max(0, sourceMs);
}
